import {
    CabHubConnectionEntity,
    CabHubTrackingPageVm,
    CabHubSurveyPageVm
} from "../cab-hub/cab-hub-tracking.entities";

import {
   CabMonthlySurveyForm, HubMonthlySurveyForm
} from "./cab-hub-survey";

import {
    CabHubConnectionEditController,
    CabHubConnectionFormController
} from "../cab-hub/cab-hub-tracking.controller";

import {
    CabHubActiveSurveysTable, 
    CabHubCompletedSurveysTable,
    CabHubConnectionsTable,
    CabHubReadOnlyConnectionsTable
} from "../cab-hub/cab-hub-tracking.table";
import { JsonItem, PickListItem } from "../../shared/components/web-form/web-form.objects";

export class CabHubTrackingPage {
    public connectionForm?:
        CabHubConnectionFormController;

    public connectionEdit?:
        CabHubConnectionEditController;

    public connectionTable?:
        CabHubConnectionsTable;

    public readOnlyConnectionTable?:
        CabHubReadOnlyConnectionsTable;

    public activeSurveysTable?:
        CabHubActiveSurveysTable;

    public completedSurveysTable?:
        CabHubCompletedSurveysTable;

    public activeSurveyForm?:
        CabMonthlySurveyForm |
        HubMonthlySurveyForm;


    constructor(
        modelJson:
            CabHubTrackingPageVm
    ) {
        $(() => {
          
            if (
                $("#cab-hub-connections-host")
                    .length
            ) {
                this.connectionForm =
                    new CabHubConnectionFormController(
                        modelJson
                    );

                this.connectionEdit =
                    new CabHubConnectionEditController(
                        this.connectionForm
                    );

                this.connectionTable =
                    new CabHubConnectionsTable(
                        "cab-hub-connections-host",
                        modelJson,
                        this.connectionEdit,
                        () => {
                            this.connectionForm
                                ?.openAddConnectionModal();
                        }
                    );

                this.connectionForm
                    .initialize();

                this.connectionTable
                    .initialize();
            }

            if (
                $("#cab-hub-readonly-connections-host")
                    .length
            ) {
                this.readOnlyConnectionTable =
                    new CabHubReadOnlyConnectionsTable(
                        "cab-hub-readonly-connections-host",
                        modelJson
                    );

                this.readOnlyConnectionTable
                    .initialize();
            }

            if (
                $("#active-surveys-table")
                    .length
            ) {
                this.activeSurveysTable =
                    new CabHubActiveSurveysTable(
                        modelJson.ActiveSurveys ?? []
                    );

                this.activeSurveysTable
                    .initialize();
            }

            if (
                $("#completed-surveys-table")
                    .length
            ) {
                this.completedSurveysTable =
                    new CabHubCompletedSurveysTable(
                        modelJson.CompletedSurveys ?? [],
                        modelJson.Scope,
                        modelJson.PickLists ?? []
                    );

                this.completedSurveysTable
                    .initialize();
            }

            this.wireSurveyCards(
                modelJson
            );

            this.wireSectionCollapseEvents();

            this.openRequestedConnection(
                modelJson
            );
        });
    }

    private wireSectionCollapseEvents():
        void {

        $("#connections-content")
            .on(
                "shown.bs.collapse",
                () => {
                    this.connectionTable
                        ?.editTable
                        .resizeTable();

                }
            );

        $("#active-surveys-content")
            .on(
                "shown.bs.collapse",
                () => {
                    this.activeSurveysTable
                        ?.resize();
                }
            );

        $("#completed-surveys-content")
            .on(
                "shown.bs.collapse",
                () => {
                    this.completedSurveysTable
                        ?.resize();
                }
            );

        $("#cab-hub-save-survey-button")
            .off(
                "click.cabHubSurveySave"
            )
            .on(
                "click.cabHubSurveySave",
                async () => {
                    if (!this.activeSurveyForm) {
                        return;
                    }

                    const saved =
                        await this.activeSurveyForm
                            .save();

                    if (saved) {
                        window.location.reload();
                    }
                }
            );
    }
    private wireSurveyCards(
        modelJson:
            CabHubTrackingPageVm
    ): void {

        $(".js-open-survey")
            .off(
                "click.cabHubSurvey"
            )
            .on(
                "click.cabHubSurvey",
                event => {
                    const $button =
                        $(event.currentTarget);

                    const surveyVm:
                        CabHubSurveyPageVm = {
                        ConnectionId:
                            Number(
                                $button.data(
                                    "connection-id"
                                )
                            ),

                        RespondentName:
                            modelJson.RespondentName,

                        CabMemberName:
                            String(
                                $button.data(
                                    "cab-member-name"
                                )
                            ),

                        HubName:
                            String(
                                $button.data(
                                    "hub-name"
                                )
                            ),

                        HubShortName:
                            String(
                                $button.data(
                                    "hub-short-name"
                                )
                            ),

                        ReportingMonth:
                            Number(
                                $button.data(
                                    "reporting-month"
                                )
                            ),

                        ReportingYear:
                            Number(
                                $button.data(
                                    "reporting-year"
                                )
                            ),

                        PickLists:
                            modelJson.PickLists ?? []
                    };
                  
                   
                    if (
                        modelJson.Scope ===
                        "cab-member"
                    ) {
                        this.activeSurveyForm =
                            new CabMonthlySurveyForm(
                                surveyVm
                            );

                        $("#cab-hub-survey-modal-title")
                            .text(
                                "Complete CAB Survey"
                            );
                    }
                    else if (
                        modelJson.Scope ===
                        "hub-member"
                    ) {
                        this.activeSurveyForm =
                            new HubMonthlySurveyForm(
                                surveyVm
                            );

                        $("#cab-hub-survey-modal-title")
                            .text(
                                "Complete Hub Survey"
                            );
                    }
                    else {
                        return;
                    }

                    $("#cab-hub-survey-modal-context")
                        .text(
                            `${surveyVm.HubShortName} — ` +
                            this.getMonthYearDisplay(
                                surveyVm.ReportingMonth,
                                surveyVm.ReportingYear
                            )
                        );

                    $("#cab-hub-survey-form-container")
                        .empty()
                        .append(
                            `<div id="cab-hub-survey-form"></div>`
                        );

                    this.activeSurveyForm
                        .initialize();

                    $("#cab-hub-survey-modal")
                        .modal(
                            "show"
                        );
                }
            );
    }

    private getMonthYearDisplay(
        month:
            number,
        year:
            number
    ): string {

        return new Date(
            year,
            month - 1,
            1
        ).toLocaleDateString(
            "en-US",
            {
                month:
                    "long",

                year:
                    "numeric"
            }
        );
    }

    private openRequestedConnection(
        modelJson:
            CabHubTrackingPageVm
    ): void {

        if (!this.connectionEdit) {
            return;
        }

        const query =
            new URLSearchParams(
                window.location.search
            );

        const requestedId =
            query.get(
                "editConnectionId"
            );

        if (!requestedId) {
            return;
        }

        const connectionId =
            Number(
                requestedId
            );

        if (
            !Number.isInteger(
                connectionId
            ) ||
            connectionId <= 0
        ) {
            console.error(
                "Invalid CAB–Hub connection ID:",
                requestedId
            );

            return;
        }

        const connection:
            CabHubConnectionEntity |
            undefined =
            modelJson.Connections
                .find(
                    item =>
                        item.Id ===
                        connectionId
                );

        if (!connection) {
            console.error(
                "CAB–Hub connection not found:",
                connectionId
            );

            return;
        }

        this.connectionEdit
            .openConnection(
                connection
            );

        query.delete(
            "editConnectionId"
        );

        const remainingQuery =
            query.toString();

        const cleanedUrl =
            window.location.pathname +
            (
                remainingQuery
                    ? `?${remainingQuery}`
                    : ""
            ) +
            window.location.hash;

        window.history.replaceState(
            {},
            document.title,
            cleanedUrl
        );
    }
   
  
 
}